<button mat-fab
        color="primary"
        data-e2e="error-reporting-trigger-button-open-report-dialog"
        matTooltip="{{'error_reporting.report_button' | translate}}"
        matTooltipPosition="before"
        (click)="openReportDialog($event)" >
    <mat-icon svgIcon="alert"></mat-icon>
</button>
